import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-dropdown",
  "use": "rt-base-dropdown-usage",
  "viewBox": "0 0 1024 1025",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1025\" id=\"rt-base-dropdown\">\n<path d=\"M70,248.3l413.5,561.3c14.3,19.5,42.6,19.5,56.8,0l413.5-561.3c14.8-19.9,1-48.5-22.9-48.5H92.9\n\tC69,199.8,55.4,228.4,70,248.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/dropdown.svg
// module id = 1210
// module chunks = 96